import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  formatCountNumber,
  formatCountNumber2digit,
  getLocalStorage,
  getSession,
  setLocalStorage,
  valdiatePage,
} from "../global";
import { useHistory } from "react-router";
import { GetDashboardCardData, dashboardData, GetDashboardFinancials, ExpandDashboardData, DeliveryReturnRatio, ReturnReasons, BusinessSummary, WithinTATDeliveryInprocess, getUserTilesById } from "../services/dashboardservice";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Sector,
} from "recharts";
import { useDispatch, useSelector } from "react-redux";
import DraftModal from "../components/draftbanner";
import { setBannerDisplayed, setLoading } from "../redux/appSlice";
import FilterPanel from "../components/dashboardFilter";
import { getMultipleSubAccountLocations } from "../services/userservice";
import DeliveryReturnChart from "../components/deliveryReturnRatioChart";
import WithinTatDeliveryChart from "../components/tatDeliveryChart";
import ReturnReasonsCharts from "../components/returnReasonsChart";
import ShippingMetrics from "../components/businessSummaryChart";
import FilterModal from "../components/FilterModal";
import AddMoreModal from "../components/addmoremodal";
import DashboardCards from "../components/dashboardcards";
import { FaMoneyBillWave , FaCalendarAlt, FaRedoAlt, FaClipboardList, FaHandshake, FaBoxOpen, FaUndoAlt, FaCogs, FaTruckMoving, FaHome, FaMotorcycle, FaHourglassHalf, FaMoneyCheckAlt, FaExchangeAlt, FaFileInvoiceDollar } from "react-icons/fa";




const Dashboard = () => {
  const dispatch = useDispatch();
  const { accounts, subaccounts, bannerDisplayed, loading, userInfo, destinations } = useSelector((state) => state.appData);
  const [detail, setDetail] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showFinancialsFilters, setshowFinancialsFilters] = useState(false);
  const [showChartsFilters, setShowChartsFilters] = useState(false);
  const [filterForChart, setFilterForChart] = useState(0);
  const [locations, setLocations] = useState([]);
  const [subAccountsLocal, setSubAccountsLocal] = useState([]);
  const [showAddMore, setShowAddMore] = useState(false);
  const [inprocessShowMore, setInprocessShowMore] = useState(false);

const tileIcons = {
  totalBooked: <FaClipboardList size={30} color="#4a90e2" />,
  totalBookedColor: "#b7d3f3ff",
  handedOver: <FaHandshake size={30} color="#f5a623" />,
  handedOverColor: "#fae9ceff",
  delivered: <FaBoxOpen size={30} color="#27ae60" />,
  deliveredColor: "#caf5dcff",
  returned: <FaUndoAlt size={30} color="#e74c3c" />,
  returnedColor:  "#fadedbff",
  inProcess: <FaCogs size={30} color="#f39c12" />,
  inProcessColor:  "#f1e3cbff",
  inTransit: <FaTruckMoving size={30} color="#3498db" />,
  inTransitColor:  "#d4e8f5ff",
  reachedDestination: <FaHome size={30} color="#9b59b6" />,
  reachedDestinationColor:  "#ebd8f3ff",
  outForDelivery: <FaMotorcycle size={30} color="#16a085" />,
  outForDeliveryColor:  "#c7f5ecff",
  shipperAdvice: <FaHourglassHalf size={30} color="#fc8a1fff" />,
  shipperAdviceColor:  "#faedd6ff",
  paymentProcessed: <FaMoneyCheckAlt size={40} color="#2ecc71" />,
  paymentProcessedColor:  "#cdf5deff",
  paymentTransferred: <FaExchangeAlt size={40} color="#f39c12" />,
  paymentTransferredColor:  "#fae8ccff",
  // paymentDue: <FaFileInvoiceDollar size={30} color="#e67e22" />,
  // paymentDueColor:  "#f8e4d2ff",
  returnInProcess: <FaRedoAlt size={30} color="#d35400" />,
  returnInProcessColor:  "#f8e0d0ff",
  deliveryRescheduled: <FaCalendarAlt size={30} color="#2980b9" />,
  deliveryRescheduledColor:  "#d0e8f8ff",
  paymentToBeTransferred: <FaMoneyBillWave  size={40} color="#29b971ff" />,
  paymentToBeTransferredColor: "#cdf5deff"

};
  
  const now = new Date();
  const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}`;
  const month = `${now.getMonth() + 1}`;
  const year = `${now.getFullYear()}`;

  const d = {
      isMonthWise: false,
      StartDate: today,
      EndDate: today,
      Year: year,
      Month: month,
      locationID: [],
      accounts: accounts,
      creditclientid: '',
      accountRecievingDate: false,
      subAccountId: [],
      destIds: [],
      originIds: []
  };
  const [filters, setFilters] = useState(d);
  const [filterUsed, setFilterUsed] = useState(false);


    const finc = {
      isMonthWise: false,
      StartDate: today,
      EndDate: today,
      Year: year,
      Month: month,
      accounts: accounts,
      creditclientid: '',
      accountRecievingDate: false
  };
  const [fincFilters, setFincFilters] = useState(finc);
  const [fincFilterUsed, setFincFilterUsed] = useState(false);

  const chartf = {
      isMonthWise: false,
      StartDate: today,
      EndDate: today,
      Year: year,
      Month: month,
      locationID: [],
      accounts: accounts,
      creditclientid: '',
      accountRecievingDate: false,
      subAccountId: [],
      destIds: [],
      originIds: []
  };
  const [chartFilters, setChartFilters] = useState(chartf);
  const [chartFilterUsed, setChartFilterUsed] = useState(false);

  const dt = new Date();
  const locale =
    navigator.languages != undefined
      ? navigator.languages[0]
      : navigator.language;
  const fullMonth = dt.toLocaleDateString(locale, { month: "long" });
  const history = useHistory();
  const [data, setData] = useState([]);
  const [advices, setAdvices] = useState({shipperAdvice: 0, lastShipperAdvice: 'Loading Advices...'});
  const [lastMonthComparision, setLastMonthComparision] = useState('');
  const [LastMonthBookedComparision, setLastMonthBookedComparision] = useState('');
  const [deliveryReturnRatio, setDeliveryReturnRatio] = useState([]);
  const [returnReasons, setReturnReasons] = useState([]);
  const [businessSummary, setBusinessSummary] = useState([]);
  const [withinTATDeliveryInprocess, setWithinTATDeliveryInprocess] = useState([]);
  const [visibleTiles, setVisibleTiles] = useState([]);
  const [activeChart, setActiveChart] = useState(null);

const ref = useRef(null);
const [height, setHeight] = useState("0px");

const toggleInprocess = () => {
  if (!inprocessShowMore) {
    setHeight(ref.current.scrollHeight + "px");
  } else {
    setHeight("0px");
  }
  setInprocessShowMore(!inprocessShowMore);
};

  const [fincData, setFincData] = useState({
    dueAmount: 0,
    processedAmount: 0,
    paidAmount: 0,
    lastPayment: 'Loading Payments...',
    nextPayment: 'Loading Next Payments...'
  });

  const [dashCardData, setDashCardData] = useState({
    deliveryVsReturnRatio: 'Loading...',
    withinTATDelivery:'Loading...',
    returnReason: "Reason Loading...",
    returnRatio: 'Loading...',
    businessSummary: 'Loading...'
  });

  

  const opendetail = async (detailtype, heading) => {
    const detail = {
      detailtype,
      start: filters.StartDate,
      end: filters.EndDate,
      filterUsed: filterUsed,
      heading: heading,
      accounts: filters.accounts,
      subAccountId: filters.subAccountId,
      locationID: filters.locationID,
      destIds: filters.destIds,
      originIds: filters.originIds
    }
    sessionStorage.setItem("customerdetail", JSON.stringify(detail));
    window.open("/cplight/customerdetail", "_blank");
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const onMouseOver = useCallback((data, index) => {
    setActiveIndex(index);
  }, []);
  const onMouseLeave = useCallback((data, index) => {
    setActiveIndex(null);
  }, []);

  useEffect(async () => {
      if (accounts.length > 0) {

          const subAccs = subaccounts.filter(e => e.accountNo.toUpperCase() === accounts[0].toUpperCase())

          setSubAccountsLocal(subAccs);

          const locs = await getMultipleSubAccountLocations({userId: userInfo.id, subAccountId: [subAccs[0].id]})
          const f = { ...filters, accounts: [accounts[0]], subAccountId: [subAccs[0].id]};

          if (locs.length > 0) {
              // d.locationID = [+locs[0].value]
              setLocations(locs);
          }
          setFilters(f);
      }
  }, [])

  useEffect( async () => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    if (valdiatePage("/")) {
      const loadData = async (accounts, source) => {
        dispatch(setLoading({ data: true }));


        // const tilesRS = await getUserTilesById(userInfo.id, source);
        // setLocalStorage("tilesData", tilesRS.data);
        // setVisibleTiles(tilesRS.data);
        // console.log(tilesRS.data);
        

        const rs = await dashboardData({accounts: accounts}, source);
        if (rs.sts == 0) {
          const { sts, ...rest } = rs;
          setLocalStorage("ddata", rest.data);
          setData(rest.data);
          setAdvices(rest.advices);
          setLastMonthComparision(rest.lastMonth);
          setLastMonthBookedComparision(rest.lastMonthBooked)
        }

        var ers = await ExpandDashboardData({accounts: accounts}, source);
        if (ers.sts == 0) {
            const { sts, ...ersrest } = ers;
            setLocalStorage("ddata",[ ...data, ...ersrest.data]);
            setData(prev =>  [ ...prev, ...ersrest.data]);
        }

        const financialsData = await GetDashboardFinancials({accounts: accounts}, source);
        if (financialsData.sts == 0) {
          const { sts, ...restFinc } = financialsData;
          setLocalStorage("fincData", restFinc.data);
          setFincData(restFinc.data);
        }

        const dashCardData = await GetDashboardCardData({accounts: accounts}, source);
        if (dashCardData.sts == 0) {
          const { sts, ...dashCard } = dashCardData;
          setLocalStorage("dashCard", dashCard.data);
          setDashCardData(dashCard.data);
        }

        dispatch(setLoading({ data: false }));
      };
      const u = getSession("userInfo");
      if (u && u.isDashboardAllowed) {
        const td = getLocalStorage("tilesData");
        if (td) {
          setVisibleTiles(td);
        }
        const dd = getLocalStorage("ddata");
        if (dd) {
          setData(dd);
        }
        const dashCard = getLocalStorage("dashCard");
        if (dashCard) {
          setLocalStorage("dashCard", dashCard);
        }

        await loadData(accounts, source);
      }
    } else {
      history.push("/login");
    }

    return () => {
      source.cancel("Operation canceled by the user.");
    };
  }, []);

  useEffect(async () => {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();
    if (valdiatePage("/")) {
      const loadData = async (accounts, source) => {
        dispatch(setLoading({ data: true }));

        if (activeChart == 1) {
            const drr = await DeliveryReturnRatio({accounts: accounts}, source);
            if (drr.sts == 0) {
              const { sts, ...restdrr } = drr;
              setLocalStorage("restdrr", restdrr.data);
              setDeliveryReturnRatio(restdrr.data);
            }
        }

        if (activeChart == 2) {
            const rr = await ReturnReasons({accounts: accounts}, source);
            if (rr.sts == 0) {
              const { sts, ...restrr } = rr;
              setLocalStorage("restrr", restrr.data);
              setReturnReasons(restrr.data);
            }
        }

        if (activeChart == 3) {
            const bs = await BusinessSummary({accounts: accounts}, source);
            if (bs.sts == 0) {
              const { sts, ...restbs } = bs;
              setLocalStorage("restbs", restbs.data);
              setBusinessSummary(restbs.data);
            }
        }

        // if (activeChart == 2) {
        //     const wdi = await WithinTATDeliveryInprocess({accounts: accounts}, source);
        //     if (wdi.sts == 0) {
        //       const { sts, ...restwdi } = wdi;
        //       setLocalStorage("restwdi", restwdi.data);
        //       setWithinTATDeliveryInprocess(restwdi.data);
        //     }
        // }

        dispatch(setLoading({ data: false }));
      };
      const u = getSession("userInfo");
      if (u && u.isDashboardAllowed) {
        const ddrr = getLocalStorage("restdrr");
        if (activeChart == 1 && ddrr) {
          setDeliveryReturnRatio(ddrr);
        }
        const drr = getLocalStorage("restrr");
        if (activeChart == 3 && drr) {
          setReturnReasons(drr);
        }
        const dbs = getLocalStorage("restbs");
        if (activeChart == 4 && dbs) {
          setBusinessSummary(dbs);
        }
        const dwdi = getLocalStorage("restwdi");
        if (activeChart == 2 && dwdi) {
          setWithinTATDeliveryInprocess(dwdi);
        }
        await loadData(accounts, source);
      }
    } else {
      history.push("/login");
    }

    return () => {
      source.cancel("Operation canceled by the user.");
    };
  }, [activeChart])


  const onSearch = async () => {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();

      if (!filters.StartDate) {
          alert('Select Start Date');
          return;
      }
      if (!filters.EndDate) {
          alert('Select End Date');
          return;
      }

      dispatch(setLoading({ data: true }));

      var rs = await dashboardData(filters, source);
      var ers = await ExpandDashboardData(filters, source);
      
      dispatch(setLoading({ data: false }));
      if (rs.sts == 0 && ers.sts == 0) {
        
        const { sts, ...rest } = rs;
        const { ...ersrest } = ers;
        setLocalStorage("ddata",[ ...rest.data, ...ersrest.data]);
        setData([ ...rest.data, ...ersrest.data]);
        setAdvices(rest.advices);
        setLastMonthComparision(rest.lastMonth);
        setLastMonthBookedComparision(rest.lastMonthBooked);
        setShowFilters(false);
        setFilterUsed(true);
      } else {
          alert(rs.msg);
      }
  }

    const onFincSearch = async () => {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();

      if (!fincFilters.StartDate) {
          alert('Select Start Date');
          return;
      }
      if (!fincFilters.EndDate) {
          alert('Select End Date');
          return;
      }

      dispatch(setLoading({ data: true }));

      var rs = await GetDashboardFinancials(fincFilters, source);

      dispatch(setLoading({ data: false }));
      if (rs.sts == 0) {
          const { sts, ...rest } = rs;
          setLocalStorage("fincData", rest.data);
          setFincData(rest.data);
          setshowFinancialsFilters(false);
          setFincFilterUsed(true);
      } else {
          alert(rs.msg);
      }
  }


  const onChartSearch = async () => {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();

      if (!chartFilters.StartDate) {
          alert('Select Start Date');
          return;
      }
      if (!chartFilters.EndDate) {
          alert('Select End Date');
          return;
      }
      
      // if(filterForChart == 2) {
      //   dispatch(setLoading({ data: true }));
      //   var rs = await WithinTATDeliveryInprocess(chartFilters, source);
      //   dispatch(setLoading({ data: false }));

      //   if (rs.sts == 0) {
      //       const { sts, ...rest } = rs;
      //       setLocalStorage("restwdi", rest.data);
      //       setWithinTATDeliveryInprocess(rest.data);
      //       setShowChartsFilters(false);
      //   } else {
      //       alert(rs.msg);
      //   }
      // }

      if(filterForChart == 2) {
        dispatch(setLoading({ data: true }));
        const rr = await ReturnReasons(chartFilters, source);
        dispatch(setLoading({ data: false }));

        if (rr.sts == 0) {
            const { sts, ...restrr } = rr;
            setLocalStorage("restrr", restrr.data);
            setReturnReasons(restrr.data);
            setShowChartsFilters(false);
        } else {
            alert(rr.msg);
        }
      }
  }

  const formatAmountPKR = (number) => {
    return new Intl.NumberFormat('en-PK', {
      style: 'currency',
      currency: 'PKR',
      minimumFractionDigits: 2, // Ensure two decimal places for paisa
      maximumFractionDigits: 2
    }).format(number);
  }

  const openFilterForChart = (val) => {
    setFilterForChart(val);
    setShowChartsFilters(true)
  }

  const openTabAndGetData = async () => {
      setDetail(!detail)

      if(!detail) {
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        if (!filters.StartDate && !filters.EndDate && filters.accounts.length == 0 && filters.locationID.length == 0 && filters.destIds == 0 && filters.originIds == 0) {
              dispatch(setLoading({ data: true }));

              var rs = await ExpandDashboardData({accounts: accounts}, source);

              dispatch(setLoading({ data: false }));
              if (rs.sts == 0) {
                  const { sts, ...rest } = rs;
                  setLocalStorage("ddata",[ ...data, ...rest.data]);
                  setData([ ...data, ...rest.data]);
              } else {
                  alert(rs.msg);
              }
        }

        if (!filters.StartDate) {
            alert('Select Start Date');
            return;
        }
        if (!filters.EndDate) {
            alert('Select End Date');
            return;
        }

        if (!filters.accounts || filters.accounts.length == 0) {
            alert('Select Account');
            return;
        }

        if (!filters.locationID || filters.locationID.length == 0) {
            alert('Select Location');
            return;
        }

        dispatch(setLoading({ data: true }));

        var rs = await ExpandDashboardData({accounts: accounts}, source);

        dispatch(setLoading({ data: false }));
        if (rs.sts == 0) {
            const { sts, ...rest } = rs;
            setLocalStorage("ddata",[ ...data, ...rest.data]);
            setData([ ...data, ...rest.data]);
        } else {
            alert(rs.msg);
        }
      }
      
  }
const options = { year: 'numeric', month: 'short', day: '2-digit' };
  return (
    getSession("userInfo") && (
      <section className="section" style={{    marginTop: '10px'}}>
        {bannerDisplayed && (
          <DraftModal
            reset={() => {
              dispatch(setBannerDisplayed({ data: false }));
            }}
          />
        )}

  <div className="dashboard-container shadow-box">

    {/* Header row with title + icons */}
    <div className="dashboard-header">
      <h2 className="shipment-heading">Shipment Details 
          <span className="current-month">
            ({filterUsed ? `${new Date(filters.StartDate).toLocaleDateString('en-CA', options)} - ${new Date(filters.EndDate).toLocaleDateString('en-CA', options)}` :  fullMonth}) 
          </span> 
      </h2> 

      <div className="header-actions">
        {/* <div 
          className="circle-action-button add-more"
          onClick={() => setShowAddMore(!showAddMore)} 
          title="Add More" 
        >
          <i className="fa fa-plus" />
        </div> */}
        <div 
          className="circle-action-button filter" 
          onClick={() => setShowFilters(!showFilters)} 
          title="Filters"
        >
          <i className="fa fa-filter" />
        </div>
      </div>
    </div>

    {showAddMore && <AddMoreModal userId={userInfo.id} setShowModal={setShowAddMore} userTilesRes={visibleTiles} setVisibleTiles={setVisibleTiles} />}
    {/* Separator */}
    {/* <hr className="dashboard-separator" /> */}

    {showFilters && (
      <FilterModal 
        userInfo={userInfo}
        filterName="Shipments" 
        accounts={accounts} 
        subaccounts={subaccounts} 
        subAccountsLocal={subAccountsLocal} 
        setSubAccountsLocal={setSubAccountsLocal}
        locations={locations} setLocations={setLocations}
        filters={filters} 
        setFilters={(w) => {
          setFilters(w);
        }}
        getMultipleSubAccountLocations={getMultipleSubAccountLocations}
        destinations={destinations}
        loading={loading}
        onSearch={onSearch}
        setShowModal={setShowFilters}
      />
    )}

    <div className="row text-center g-3 tiles-margin">

      
            <StatCard2
              title="Total Booked"
              icon={tileIcons.totalBooked}
              change={data.length > 0 ? formatAmountPKR(data.filter(e => e.processName == "TotalBooked")[0]?.codAmount || 0) : 0}
              color={tileIcons.totalBookedColor}
              value={data.length > 0 ? data.filter(e => e.processName == "TotalBooked")[0]?.processCount || 0 : 0}
              WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "TotalBooked")[0]?.withinKPIPercentage || 0 : 0}
              OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "TotalBooked")[0]?.outSideKPIPercentage || 0 : 0}
              openDetail={(e) => {
                e.preventDefault(); 
                opendetail("TotalBooked", "Total Booked")
              }}
            />
      

      
            <StatCard2
              title="Handed Over To M&P"
              icon={tileIcons.handedOver}
              change={data.length > 0 ? formatAmountPKR(data.filter(e => e.processName == "Approved")[0]?.codAmount || 0) : 0}
              color={tileIcons.handedOverColor}
              value={data.length > 0 ? data.filter(e => e.processName == "Approved")[0]?.processCount || 0 : 0}
              WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "Approved")[0]?.withinKPIPercentage || 0 : 0}
              OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "Approved")[0]?.outSideKPIPercentage || 0 : 0}
              openDetail={(e) => {
                e.preventDefault(); 
                opendetail("approved", "Handed Over To M&P")
              }}
            />
      

            <StatCard2
              title="Delivered"
              icon={tileIcons.delivered}
              change={data.length > 0 ? formatAmountPKR(data.filter(e => e.processName == "Delivered")[0]?.codAmount || 0) : 0}
              color={tileIcons.deliveredColor}
              value={data.length > 0 ? data.filter(e => e.processName == "Delivered")[0]?.processCount || 0 : 0}
              WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "Delivered")[0]?.withinKPIPercentage || 0 : 0}
              OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "Delivered")[0]?.outSideKPIPercentage || 0 : 0}
              openDetail={(e) => {
                e.preventDefault(); 
                opendetail("delivered", "Delivered")
              }}
            />
      




            <StatCard2
              title="Returned"
              icon={tileIcons.returned}
              change={data.length > 0 ? formatAmountPKR(data.filter(e => e.processName == "Returned")[0]?.codAmount || 0) : 0}
              color={tileIcons.returnedColor}
              value={data.length > 0 ? data.filter(e => e.processName == "Returned")[0]?.processCount || 0 : 0}
              WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "Returned")[0]?.withinKPIPercentage || 0: 0}
              OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "Returned")[0]?.outSideKPIPercentage || 0 : 0}
              openDetail={(e) => {
                e.preventDefault(); 
                opendetail("rts","Returned")
              }}
            />
      



            <StatCardInprocess
              title="In-process"
              icon={tileIcons.inProcess}
              change="1.8% Up from yesterday"
              color={tileIcons.inProcessColor}
              value={data.length > 0 ? data.filter(e => e.processName == "InProcess")[0]?.processCount || 0 : 0}
              WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "InProcess")[0]?.withinKPIPercentage || 0 : 0}
              OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "InProcess")[0]?.outSideKPIPercentage || 0 : 0}
              openDetail={(e) => {
                e.preventDefault(); 
                opendetail("inprocess","In-process")
              }}
              setShowAddMore={toggleInprocess} 
              showAddMore={inprocessShowMore}
            /> 

            


            
            {/* <StatCardInprocessButton
              title="In-process"
              icon={tileIcons.inProcess}
              change="1.8% Up from yesterday"
              color={tileIcons.inProcessColor}
              value={data.length > 0 ? data.filter(e => e.processName == "InProcess")[0]?.processCount || 0 : 0}
              WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "InProcess")[0]?.withinKPIPercentage || 0 : 0}
              OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "InProcess")[0]?.outSideKPIPercentage || 0 : 0}
              openDetail={(e) => {
                e.preventDefault(); 
                opendetail("inprocess")
              }}
              setShowAddMore={setShowAddMore} 
              showAddMore={showAddMore}
            /> */}
      
       <StatCard2
              title="Shipper Advice"
              value={advices.shipperAdvice}
              icon={tileIcons.shipperAdvice}
              change={`${advices.lastShipperAdvice}`}
              color={tileIcons.shipperAdviceColor}
              WithinKPIPercentage={12}
              OutSideKPIPercentage={82}
              openDetail={(e) => {
                e.preventDefault(); 
                window.open('/cplight/shipperadvice', '_blank');
              }}
            />

{
  <div
  className="inprocess-transition"
  style={{ height: height }}
>
  <div ref={ref}>
    <div className="inprocess-break-container p-3">

    <div className="break-title mb-3" style={{ display: "flex", alignItems: "center", flexDirection: "row", gap: "8px" }}>
      <span className="break-icon"></span> In-Process Breakdown
      {/* <span className="break-icon">⤵</span> In-Process Breakdown */}
    </div>

    <div className="row g-3 tiles-row-inprocess">

      {
              <StatCard
                title="In-Transit"
                icon={tileIcons.inTransit}
                change="8.5% Up from yesterday"
                color={tileIcons.inTransitColor}
                value={data.length > 0 ? data.filter(e => e.processName == "InTransit")[0]?.processCount || 0 : 0}
                WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "InTransit")[0]?.withinKPIPercentage || 0 : 0}
                OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "InTransit")[0]?.outSideKPIPercentage || 0 : 0}      
                openDetail={(e) => {
                  e.preventDefault(); 
                  opendetail("intransit","In-Transit")
                }}     
              />
      }

      {
              <StatCard
                title="Reached At Destination"
                icon={tileIcons.reachedDestination}
                change="1.3% Up from past week"
                color={tileIcons.reachedDestinationColor}
                value={data.length > 0 ? data.filter(e => e.processName == "DestinationInbound")[0]?.processCount || 0 : 0}
                WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "DestinationInbound")[0]?.withinKPIPercentage || 0 : 0}
                OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "DestinationInbound")[0]?.outSideKPIPercentage || 0 : 0}
                openDetail={(e) => {
                  e.preventDefault(); 
                  opendetail("reachedatdestination","Reached At Destination")
                }}    
              />
      }


      {
              <StatCard
                title="Out For Delivery"
                icon={tileIcons.outForDelivery}
                change="4.3% Down from yesterday"
                color={tileIcons.outForDeliveryColor}
                value={data.length > 0 ? data.filter(e => e.processName == "OutforDelivery")[0]?.processCount || 0 : 0}
                WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "OutforDelivery")[0]?.withinKPIPercentage || 0 : 0}
                OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "OutforDelivery")[0]?.outSideKPIPercentage || 0 : 0}
                openDetail={(e) => {
                  e.preventDefault(); 
                  opendetail("outfordelivery", "Out For Delivery")
                }}   
              />
      }


      {
              <StatCard
                title="Delivery Rescheduled"
                // icon="⏰"
                icon={tileIcons.deliveryRescheduled}
                change="1.8% Up from yesterday"
                color={tileIcons.deliveryRescheduledColor}
                value={data.length > 0 ? data.filter(e => e.processName == "DeliveryRechedule")[0]?.processCount || 0 : 0}
                WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "DeliveryRechedule")[0]?.withinKPIPercentage || 0 : 0}
                OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "DeliveryRechedule")[0]?.outSideKPIPercentage || 0 : 0}
                openDetail={(e) => {
                  e.preventDefault(); 
                  opendetail("deliveryrescheduled","Delivery Rescheduled")
                }}  
              />
      }


      {
              <StatCard
                title="Return In-Process"
                // icon="🔄"
                icon={tileIcons.returnInProcess}
                
                change="1.8% Up from yesterday"
                color={tileIcons.returnInProcessColor}
                value={data.length > 0 ? data.filter(e => e.processName == "ReturnInProcess")[0]?.processCount || 0 : 0}
                WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "ReturnInProcess")[0]?.withinKPIPercentage || 0 : 0}
                OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "ReturnInProcess")[0]?.outSideKPIPercentage || 0 : 0}
                openDetail={(e) => {
                  e.preventDefault(); 
                  opendetail("returninprocess","Return In-Process")
                }}  
              />
      }

           </div>
    </div>

    </div>
</div>
}




          </div>

          {/* <div className="show-more-detail">
            <div
              className="circle-add-button"
              onClick={openTabAndGetData}
              title="Toggle Filters"
              style={{textAlign: 'center', placeContent: 'center'}}
            >
              {!detail ? <i className="fa fa-plus"></i> : <i className="fa fa-minus"></i>} 
            </div>
          </div> */}

          {/* <div className="show-more-detail">
            <button
              className="circle-add-button"
              onClick={openTabAndGetData}
            >
              <i class="fa fa-expand"></i>
            </button>
          </div> */}

            {/* <div className="row text-center g-3 tiles-margin">
                    {
                      visibleTiles.length > 0 && visibleTiles.filter(e => e.name == 'In-Transit')[0]?.isActive  &&
                            <StatCard
                              title="In-Transit"
                              icon="🚚"
                              change="8.5% Up from yesterday"
                              color="green"
                              value={data.length > 0 ? data.filter(e => e.processName == "InTransit")[0]?.processCount || 0 : 0}
                              WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "InTransit")[0]?.withinKPIPercentage || 0 : 0}
                              OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "InTransit")[0]?.outSideKPIPercentage || 0 : 0}      
                              openDetail={(e) => {
                                e.preventDefault(); 
                                opendetail("intransit")
                              }}     
                            />
                    }

                    {
                      visibleTiles.length > 0 && visibleTiles.filter(e => e.name == 'Reached At Destination')[0]?.isActive  &&
                            <StatCard
                              title="Reached At Destination"
                              icon="🏠"
                              change="1.3% Up from past week"
                              color="green"
                              value={data.length > 0 ? data.filter(e => e.processName == "DestinationInbound")[0]?.processCount || 0 : 0}
                              WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "DestinationInbound")[0]?.withinKPIPercentage || 0 : 0}
                              OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "DestinationInbound")[0]?.outSideKPIPercentage || 0 : 0}
                              openDetail={(e) => {
                                e.preventDefault(); 
                                opendetail("reachedatdestination")
                              }}    
                            />
                    }


                    {
                      visibleTiles.length > 0 && visibleTiles.filter(e => e.name == 'Out For Delivery')[0]?.isActive  &&
                            <StatCard
                              title="Out For Delivery"
                              icon="🏍️"
                              change="4.3% Down from yesterday"
                              color="red"
                              value={data.length > 0 ? data.filter(e => e.processName == "OutforDelivery")[0]?.processCount || 0 : 0}
                              WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "OutforDelivery")[0]?.withinKPIPercentage || 0 : 0}
                              OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "OutforDelivery")[0]?.outSideKPIPercentage || 0 : 0}
                              openDetail={(e) => {
                                e.preventDefault(); 
                                opendetail("outfordelivery")
                              }}   
                            />
                    }


                    {
                      visibleTiles.length > 0 && visibleTiles.filter(e => e.name == 'Delivery Rescheduled')[0]?.isActive  &&
                            <StatCard
                              title="Delivery Rescheduled"
                              icon="⏰"
                              change="1.8% Up from yesterday"
                              color="green"
                              value={data.length > 0 ? data.filter(e => e.processName == "DeliveryRechedule")[0]?.processCount || 0 : 0}
                              WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "DeliveryRechedule")[0]?.withinKPIPercentage || 0 : 0}
                              OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "DeliveryRechedule")[0]?.outSideKPIPercentage || 0 : 0}
                              openDetail={(e) => {
                                e.preventDefault(); 
                                opendetail("deliveryrescheduled")
                              }}  
                            />
                    }


                    {
                      visibleTiles.length > 0 && visibleTiles.filter(e => e.name == 'Return In-Process')[0]?.isActive  &&
                            <StatCard
                              title="Return In-Process"
                              icon="🔄"
                              change="1.8% Up from yesterday"
                              color="green"
                              value={data.length > 0 ? data.filter(e => e.processName == "ReturnInProcess")[0]?.processCount || 0 : 0}
                              WithinKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "ReturnInProcess")[0]?.withinKPIPercentage || 0 : 0}
                              OutSideKPIPercentage={data.length > 0 ? data.filter(e => e.processName == "ReturnInProcess")[0]?.outSideKPIPercentage || 0 : 0}
                              openDetail={(e) => {
                                e.preventDefault(); 
                                opendetail("returninprocess")
                              }}  
                            />
                    }

            </div> */}

            </div>



  <div className="dashboard-container shadow-box" style={{ marginTop: '17px' }}>

    {/* Header row with title + icons */}
    <div className="dashboard-header">
      <h2 className="shipment-heading">Financial Details
          <span className="current-month">
          ({fincFilterUsed ? `${new Date(fincFilters.StartDate).toLocaleDateString('en-CA', options)} - ${new Date(fincFilters.EndDate).toLocaleDateString('en-CA', options)}` :  fullMonth}) 
        </span> 
      </h2>

      <div className="header-actions">
        <div 
          className="circle-action-button filter" 
          onClick={() => setshowFinancialsFilters(!showFinancialsFilters)}
          title="Toggle Filters"
        >
          <i className="fa fa-filter" />
        </div>
      </div>
    </div>

          {/* {showFinancialsFilters && <FilterPanel 
                                      userInfo={userInfo}
                                      filterName="Financial" 
                                      accounts={accounts}   
                                      subaccounts={subaccounts} 
                                      subAccountsLocal={subAccountsLocal} 
                                      setSubAccountsLocal={setSubAccountsLocal}
                                      locations={locations} setLocations={setLocations}
                                      filters={fincFilters} setFilters={setFincFilters}
                                      getMultipleSubAccountLocations={getMultipleSubAccountLocations}
                                      destinations={destinations}
                                      loading={loading}
                                      onSearch={onFincSearch}
                                  />} */}


          
        {showFinancialsFilters && (
          <FilterModal 
            userInfo={userInfo}
            filterName="Financial" 
            accounts={accounts} 
            subaccounts={subaccounts} 
            subAccountsLocal={subAccountsLocal} 
            setSubAccountsLocal={setSubAccountsLocal}
            locations={locations} setLocations={setLocations}
            filters={fincFilters} 
            setFilters={(d) => {
              setFincFilterUsed(true);
              setFincFilters(d);
            }}
            getMultipleSubAccountLocations={getMultipleSubAccountLocations}
            destinations={destinations}
            loading={loading}
            onSearch={onFincSearch}
            setShowModal={setshowFinancialsFilters}
          />
        )}

          <div className="row text-center g-3 tiles-margin">
            <StatCard3
              title="Payment Processed"
              value={formatAmountPKR(fincData.processedAmount)}
              icon={tileIcons.paymentProcessed}
              change={`Last Payment: ${fincData.lastPayment}`}
              color={tileIcons.paymentProcessedColor}
              WithinKPIPercentage={12}
              OutSideKPIPercentage={82}
              
            />
            <StatCard3
              title="Payment Transfered"
              value={formatAmountPKR(fincData.paidAmount)}
              icon={tileIcons.paymentTransferred}
              change={`Last Payment: ${fincData.lastPayment}`}
              color={tileIcons.paymentTransferredColor}
              WithinKPIPercentage={12}
              OutSideKPIPercentage={82}

            />
            <StatCard3
              title="Payment to be Transferred"
              value={formatAmountPKR(fincData.processedAmount - fincData.paidAmount)}
              icon={tileIcons.paymentToBeTransferred}
              change={`Last Payment: ${fincData.lastPayment}`}
              color={tileIcons.paymentToBeTransferredColor}
              WithinKPIPercentage={12}
              OutSideKPIPercentage={82}
              
            />
            {/* <StatCard3
              title="Payment Due"
              value={formatAmountPKR(fincData.dueAmount)}
              // icon="🕰️"
    //           icon={<i className="fa fa-tasks" style={{padding: '0px 8px',
    // color: '#ff6363'}} aria-hidden={true}></i>}
              icon={tileIcons.paymentDue}
              change={`Next Expected Payment: ${fincData.nextPayment}`}
              color={tileIcons.paymentDueColor}
              WithinKPIPercentage={12}
              OutSideKPIPercentage={82}
            /> */}
          </div>

  </div>

          {/* <div className="show-more-detail">
            <div
              className="circle-add-button"
              onClick={() => setshowFinancialsFilters(!showFinancialsFilters)}
              title="Toggle Filters"
              style={{textAlign: 'center', placeContent: 'center'}}
            >
              <i className="fa fa-filter" /> 
            </div>
          </div> */}


  <div className="Chart-container shadow-box" style={{ marginTop: '17px' }}>

    {/* Header row with title + icons */}
    {/* <div className="dashboard-header">
      <h2 className="shipment-heading">Data Visuals</h2>

      <div className="header-actions">
        <div 
          className="circle-action-button filter" 
          onClick={() => setShowChartsFilters(!showChartsFilters)}
          title="Toggle Filters"
        >
          <i className="fa fa-filter" />
        </div>
      </div>
    </div> */}

          
        {showChartsFilters && (
          <FilterModal 
            userInfo={userInfo}
            filterName="Charts Filter" 
            accounts={accounts} 
            subaccounts={subaccounts} 
            subAccountsLocal={subAccountsLocal} 
            setSubAccountsLocal={setSubAccountsLocal}
            locations={locations} setLocations={setLocations}
            filters={chartFilters} setFilters={(d) => {
              setChartFilterUsed(true);
              setChartFilters(d);
            }}
            getMultipleSubAccountLocations={getMultipleSubAccountLocations}
            destinations={destinations}
            loading={loading}
            onSearch={onChartSearch}
            setShowModal={setShowChartsFilters}
          />
        )}

      <DashboardCards 
        charts={[
          <DeliveryReturnChart deliveryReturnRatio={deliveryReturnRatio} />,
          // <WithinTatDeliveryChart withinTATDeliveryInprocess={withinTATDeliveryInprocess} />,
          <ReturnReasonsCharts returnReasons={returnReasons} />,
          <ShippingMetrics businessSummary={businessSummary} />
        ]}
        openFilterForChart={openFilterForChart}
        setActiveChart={setActiveChart}
        dashCardData={dashCardData}
        fullMonth={fullMonth}
      />


        {/* <div className="row">
            <div className="col-md-6 col-sm-12" style={{ marginBottom: '5px'}}><DeliveryReturnChart deliveryReturnRatio={deliveryReturnRatio} /></div>
            <div className="col-md-6 col-sm-12" style={{ marginBottom: '5px'}}><WithinTatDeliveryChart withinTATDeliveryInprocess={withinTATDeliveryInprocess} /></div>
          </div>

          <div className="row">
            <div className="col-md-6 col-sm-12"  style={{ marginTop: '5px'}}><ReturnReasonsCharts returnReasons={returnReasons} /></div>
            <div className="col-md-6 col-sm-12" style={{ marginTop: '5px'}}><ShippingMetrics businessSummary={businessSummary}/></div>
          </div> */}


  </div>  




          {/* <div className="show-more-detail">
            <div
              className="circle-add-button"
              onClick={() => setShowChartsFilters(!showChartsFilters)}
              title="Toggle Filters"
              style={{textAlign: 'center', placeContent: 'center'}}
            >
              <i className="fa fa-filter" /> 
            </div>
          </div>

          {showChartsFilters && <FilterPanel 
                            userInfo={userInfo}
                            filterName="Charts Filter" 
                            accounts={accounts} 
                            subaccounts={subaccounts} 
                            subAccountsLocal={subAccountsLocal} 
                            setSubAccountsLocal={setSubAccountsLocal}
                            locations={locations} setLocations={setLocations}
                            filters={chartFilters} setFilters={setChartFilters}
                            getMultipleSubAccountLocations={getMultipleSubAccountLocations}
                            destinations={destinations}
                            loading={loading}
                            onSearch={onChartSearch}
                        />}

          <div style={{display: 'flex'}}>
            <div style={{width: '50%', marginRight: '5px', marginBottom: '5px'}}><DeliveryReturnChart deliveryReturnRatio={deliveryReturnRatio} /></div>
            <div style={{width: '50%', marginLeft: '5px', marginBottom: '5px'}}><WithinTatDeliveryChart withinTATDeliveryInprocess={withinTATDeliveryInprocess} /></div>
          </div>

          <div style={{display: 'flex'}}>
            <div style={{width: '50%',  marginRight: '5px', marginTop: '5px'}}><ReturnReasonsCharts returnReasons={returnReasons} /></div>
            <div style={{width: '50%', marginLeft: '5px', marginTop: '5px'}}><ShippingMetrics businessSummary={businessSummary}/></div>
          </div> */}







          {/* <div className="chart-section p-3 bg-white rounded shadow-sm">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="fw-bold">Shipment Statics</h5>
              <select className="form-select w-auto">
                <option>Month</option>
              </select>
            </div>
              <DeliveryReturnChart />
            <div className="bar-chart-placeholder text-center p-5 text-muted">
            </div>
          </div> */}


      </section>
    )
  );
};


const StatCard = ({ title, value, icon, change, color, WithinKPIPercentage, OutSideKPIPercentage, openDetail }) => {
  return (
    // <div className="col-xxl-2  col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-6">
<div className="col-12 col-sm-6 col-lg-3 col-xl-3 col-xxl-2">
      <div className="stat-card bg-white  rounded shadow" style={{ padding: '0.5rem 0.5rem 0.2rem 0.5rem' }}>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <div className="stat-title fw-bold">{title}</div>
            <div className="stat-value fs-4 fw-bold dashboard-count-placement"><a style={{ cursor: 'pointer', color: '#e25a0c' }} onClick={openDetail} >{formatCountNumber(value || 0)}</a> </div>
          </div>
          <div>
               <div className="icon-box fs-1" style={{ backgroundColor: color }} > {icon}</div>
          </div>

        </div>
        {/* <div className="tat-container">
          <div style={{color: '#ed5151'}} className={`stat-change`}>{OutSideKPIPercentage || 0}% OTAT</div>
          <div style={{color: '#03a503'}} className={`stat-change`}>{WithinKPIPercentage || 0}% WTAT</div>
        </div> */}
      </div>
    </div>
  );
};



// const StatCardInprocess = ({ title, value, icon, change, color, WithinKPIPercentage, OutSideKPIPercentage, openDetail, setShowAddMore, showAddMore  }) => {
//   return (
//     // <div className="col-xxl-2  col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-6">
// <div className="col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-2">
//     <div className="stat-card bg-white rounded shadow p-3 inprocess-parent">
//       <div className="d-flex justify-content-between align-items-center">
//         <div>
//           <div className="stat-title fw-bold">In-Process</div>
//           <div className="stat-value fs-4 fw-bold dashboard-count-placement">
//             <a style={{ cursor: "pointer", color: "#e25a0c" }} onClick={openDetail}>
//               {formatCountNumber(value)}
//             </a>
//           </div>
//         </div>

//         <div className="icon-box fs-1" style={{ backgroundColor: color }}>
//           {icon}
//         </div>
//       </div>

//       <div className="text-end mt-1">
//         <button className="btn btn-sm btn-outline-primary px-2 py-1"
//                 onClick={() => setShowAddMore(!showAddMore)}>
//           View Breakdown
//         </button>
//       </div>
//     </div>
//   </div>
//   );
// };

const StatCardInprocess = ({ title, value, icon, change, color, WithinKPIPercentage, OutSideKPIPercentage, openDetail, setShowAddMore, showAddMore }) => {
  return (
    <div className={`col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-2 ${showAddMore ? "inprocess-connector" : ""}`}>
      <div className="stat-card bg-white  rounded shadow" style={{ padding: '0.5rem 0.5rem 0.2rem 0.5rem' }}>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <div className="stat-title fw-bold">{title}</div>
            <div className="stat-value fs-4 fw-bold dashboard-count-placement"><a style={{ cursor: 'pointer', color: '#e25a0c' }} onClick={openDetail} >{formatCountNumber(value || 0)}</a></div>
          </div>
          <div>
               <div className="icon-box fs-1"  style={{ backgroundColor: color, marginBottom: '2px' }} > {icon} </div>
          </div>

        </div>
        <div className="tat-container-inprocess">
          <div 
            className="circle-action-button-tile add-more"
            onClick={() => setShowAddMore(!showAddMore)} 
            title="Add More" 
            style={{ marginTop: '3px' }}
          >
            {showAddMore ? <i className="fa fa-minus" />  : <i className="fa fa-plus" /> }  
          </div> 
          <span             onClick={() => setShowAddMore(!showAddMore)} 
 className="link-inprocess" style={{color: 'darkslateblue',
    marginTop: '2px !important', marginLeft: '3px', cursor: 'pointer'}}>{showAddMore ? "Hide" : "Show"} Breakdown</span>
        </div>
      </div>
    </div>
  );
};

const StatCardInprocessButton = ({ title, value, icon, change, color, WithinKPIPercentage, OutSideKPIPercentage, openDetail, setShowAddMore, showAddMore }) => {
  return (
    // <div className="col-xxl-2  col-xl-3 col-lg-4 col-md-6 col-sm-6 col-xs-6">
    <div className="col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-2">
      <div className="stat-card bg-white  rounded shadow" style={{ padding: '0.5rem 0.5rem 0.2rem 0.5rem' }}>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <div className="stat-title fw-bold">{title}</div>
            <div className="stat-value fs-4 fw-bold dashboard-count-placement"><a style={{ cursor: 'pointer', color: '#e25a0c' }} onClick={openDetail} >{formatCountNumber(value || 0)}</a> </div>
          </div>
          <div>
            <div 
          className="circle-action-button add-more"
          onClick={() => setShowAddMore(!showAddMore)} 
          title="Add More" 
        >
          <i className="fa fa-plus" />
        </div>
               <div className="icon-box fs-1" style={{ backgroundColor: color }} > {icon}</div>
          </div>

        

        </div>
        {/* <div className="tat-container">
          <div style={{color: '#ed5151'}} className={`stat-change`}>{OutSideKPIPercentage || 0}% OTAT</div>
          <div style={{color: '#03a503'}} className={`stat-change`}>{WithinKPIPercentage || 0}% WTAT</div>
        </div> */}
      </div>
    </div>
  );
};


// const StatCard2 = ({ title, value, icon, change, color, WithinKPIPercentage, OutSideKPIPercentage, openDetail }) => {
//   return (
//     <div className="col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-2">
//       <div className="stat-card bg-white  rounded shadow" style={{ padding: '0.5rem 0.5rem 0.2rem 0.5rem' }}>
//         <div className="align-items-center justify-content-between">
//           <div>
//             <div className="stat-title fw-bold">{title}</div>
//           </div>
//           <div className="d-flex" style={{justifyContent: 'space-between'}}>
//                <div className="stat-value fs-4 fw-bold dashboard-count-placement"><a style={{ cursor: 'pointer', color: '#e25a0c' }} onClick={openDetail} >{formatCountNumber(value || 0)}</a></div>
//                <div className="icon-box fs-1" style={{ backgroundColor: color }} > {icon} </div>
//           </div>

//         </div>
//         <div className="tat-container">
//           <div>{change}</div>
//         </div>
//       </div>
//     </div>
//   );
// };


const StatCard2 = ({ title, value, icon, change, color, WithinKPIPercentage, OutSideKPIPercentage, openDetail }) => {
  return (
    <div className="col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-2">
      <div className="stat-card bg-white  rounded shadow" style={{ padding: '0.5rem 0.5rem 0.2rem 0.5rem' }}>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <div className="stat-title fw-bold">{title}</div>
            <div className="stat-value fs-4 fw-bold dashboard-count-placement"><a style={{ cursor: 'pointer', color: '#e25a0c' }} onClick={openDetail} >{formatCountNumber(value || 0)}</a></div>
          </div>
          <div>
               <div className="icon-box fs-1" style={{ backgroundColor: color }} > {icon} </div>
          </div>

        </div>
        <div className="tat-container">
          <div> {title == 'Shipper Advice' ? 'Last Advice' : 'COD Amount'}:  {change}</div>
        </div>
      </div>
    </div>
  );
};

const StatCard3 = ({ title, value, icon, change, color, WithinKPIPercentage, OutSideKPIPercentage, openDetail }) => {
  return (
    <div className="col-xxl-4  col-xl-4 col-lg-4 col-md-6 col-sm-6 col-xs-6">
      <div className="stat-card bg-white rounded shadow" style={{ padding: '0.5rem 0.5rem 0.2rem 0.5rem' }}>
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <div className="stat-title fw-bold">{title}</div>
            <div className="stat-value fs-4 fw-bold dashboard-count-placement"><a style={{ color: '#e25a0c' }} onClick={openDetail} >{value}</a></div>
          </div>
          <div>
               <div className="icon-box-payment fs-1" style={{ backgroundColor: color }}> {icon} </div>
          </div>

        </div>
        {/* <div className="tat-container">
          <div>{change}</div>
        </div> */}
      </div>
    </div>
  );
};

export default Dashboard;

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill="#333"
      >{`${value}`}</text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#999"
      >
        {`(${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};
